import type { SxProps } from '@mui/material';
import { Box } from '@mui/material';
import type { PropsWithChildren } from 'react';
import React from 'react';
import { TOP_OF_PAGE_MARGIN_PIXELS } from '../../../pages/enrollment-abc/constants';
import { CENTERED_CONTENT_STYLES } from './full-page-centered-content-wrapper';
import type { ITheme } from '../../styles/theme';

export const HEADER_ID = 'main-navbar-header';
export const FOOTER_ID = 'main-footer';

interface IProps {
  isPageContentCentered?: boolean;
  isPageContentWithTopGap?: boolean;
  /** from 1 not 0 */
  contentAsChildIndex?: number;
  theme: ITheme;
  sx?: SxProps;
  contentSx?: SxProps;
}

export const FullPageHeightWrapper: React.FC<PropsWithChildren<IProps>> = ({
  isPageContentCentered = false,
  isPageContentWithTopGap = false,
  contentAsChildIndex,
  theme,
  children,
  sx = {},
  contentSx = {},
}) => {
  const styles: SxProps = {
    minHeight: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    background: theme.colors.eggshellBackground,

    // If a page has a header,
    // the next element after the header is the content

    // content
    [contentAsChildIndex && contentAsChildIndex > 0
      ? `> :nth-of-type(${contentAsChildIndex})`
      : `#${HEADER_ID} + div`]: {
      flex: '1 0 auto',
      paddingTop: isPageContentWithTopGap
        ? `${TOP_OF_PAGE_MARGIN_PIXELS}px`
        : undefined,
      ...(isPageContentCentered ? CENTERED_CONTENT_STYLES : {}),
      ...contentSx,
    },
    ...sx,
  };

  return <Box sx={styles}>{children}</Box>;
};
